import React from 'react';

const AddressFields = ({
  prefix,
  countries,
  formData,
  errors,
  loading,
  onChange,
  onCountryChange,
}) => {
  const countryField = `${prefix}_country`;
  const stateField = `${prefix}_state`;
  const selectedCountry = countries.find(
    (country) => String(country.id) === String(formData[countryField]),
  );
  const states = selectedCountry?.states || [];

  const renderField = (name, label, required = true) => (
    <div className="form-group">
      <label htmlFor={name} className="form-label">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <input
        type="text"
        id={name}
        disabled={loading}
        name={name}
        className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
        value={formData[name]}
        onChange={onChange}
        required={required}
      />
      {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
    </div>
  );

  return (
    <div className="container-fluid px-0">
      <div className="row">
        <div className="col-12">
          {renderField(`${prefix}_address`, 'Address')}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {renderField(`${prefix}_city`, 'City')}
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor={countryField} className="form-label">
              Country <span className="text-danger">*</span>
            </label>
            <select
              id={countryField}
              disabled={loading}
              name={countryField}
              className={`form-control${errors[countryField] ? ' is-invalid' : ''}`}
              value={formData[countryField] || ''}
              onChange={onCountryChange}
              required
            >
              <option value="">Select a country</option>
              {countries.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.name}
                </option>
              ))}
            </select>
            {errors[countryField] && (
              <div className="invalid-feedback">{errors[countryField]}</div>
            )}
          </div>
        </div>
        <div className="col-md-6">
          {states.length > 0 ? (
            <div className="form-group">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor={stateField} className="form-label">
                State / Province <span className="text-danger">*</span>
              </label>
              <select
                id={stateField}
                disabled={loading}
                name={stateField}
                className={`form-control${errors[stateField] ? ' is-invalid' : ''}`}
                value={formData[stateField] || ''}
                onChange={onChange}
                required
              >
                <option value="">Select a state / province</option>
                {states.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                ))}
              </select>
              {errors[stateField] && (
                <div className="invalid-feedback">{errors[stateField]}</div>
              )}
            </div>
          ) : (
            renderField(stateField, 'State / Province', Boolean(selectedCountry))
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {renderField(`${prefix}_zip_code`, 'Zip Code')}
        </div>
      </div>
    </div>
  );
};

export default AddressFields;
